import { useCallback } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";

import { store } from "@/store/store";
import { CustomerNote } from "@/shared/models/CustomerNote";
import { Utilities } from "@/shared/utils/utilities";
import { DateTimeFormatStrings } from "@/shared/enums";
import { ReviewCustomersApi } from "@/shared/api/ReviewCustomers.api";
import { setToastInfo } from "@/redux/shareSlice";

const CustomerComment = ({ notes }: { notes: CustomerNote[] }) => {
  const handleAttachmentDownload = useCallback(async (id: string) => {
    var fileName = await ReviewCustomersApi.getAttachment(id);
    !Utilities.isNullOrEmptyString(fileName) && store.dispatch(setToastInfo(`Attachment is downloaded successfully as ${fileName}.`));
  }, []);

  return (
    <Container>
      {notes && notes.length > 0 ? (
        notes.map((note) => (
          <Row>
            {
              <Col>
                <span>
                  <b>
                    {note.author} ({note.noteType})
                  </b>
                </span>
                <p className="mxw-350">{note.text}</p>
                {note.attachments && note.attachments.length > 0 && (
                  <div>
                    <Button variant="link" onClick={async () => await handleAttachmentDownload(note.attachments[0].id)}>
                      {note.attachments[0].name}
                    </Button>
                  </div>
                )}
                <span className="opacity-60">{Utilities.formatDate(new Date(note.created), DateTimeFormatStrings.FORMAT_14)}</span>
                <hr />
              </Col>
            }
          </Row>
        ))
      ) : (
        <></>
      )}
    </Container>
  );
};

export default CustomerComment;
